<template>
  <div ref="card"  class="profile-card" @click="$emit('toggle-orgs')" >

      <div class="image-container" v-if="isSuperUser && isCardInView">
        <transition name="fade-profile" mode="out-in">
          <img class="profile-img" :src="compImg" v-if="isExpanded">
          <div v-else class="profile-img">{{ user.orgId }}</div>
        </transition>
      </div>

      <img v-else class="profile-img" :src="compImg">
      <div class="profile-text-container">
          <p class="title">{{title}}</p>
          <p class="subtitle">{{subtitle}}</p>
      </div>
      <img
          class="profile-card-dropdown"
          :class="{ 'is-open': isOrgsOpen }"
          :src="require('../../assets/icons/chevron-down.svg')"
          alt="multi org dropdown"
      >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    emits: ["toggle-orgs"],
    props: {
        title: String,
        subtitle: [String, Number],
        img: String,
        manageableOrgs: Array,
        isExpanded: {
          type: Boolean,
          default: true
        },
        isOrgsOpen: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            observer: null,
            isCardInView: true
        }
    },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.card;
      if (!el || !window.IntersectionObserver) return;

      const root = document.querySelector("#side-nav") || null;

      this.observer = new IntersectionObserver(
          ([entry]) => {
            this.isCardInView = entry.isIntersecting;
          },
          { root, threshold: 0.01 }
      );

      this.observer.observe(el);
    });
  },

  unmounted() {
    this.observer?.disconnect();
  },

    computed: {
        ...mapState('account', ['user', "isSuperUser"]),
        compImg(){
            return this.img ? require(`../../assets/${this.img}`) : "";
        }
    },
}
</script>

<style lang="scss" scoped>
    .profile-card {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 25px 25px 18px 25px;
        transition: 0.3s ease !important;

        &:hover {
            cursor: pointer;
        }
    }
    .image-container {
      min-width: 40px;
      width: 40px;
      min-height: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #4f61e8;
      border-radius: 8px;
      overflow: hidden;
      transition: all 180ms ease !important;
    }

    .profile-img {
        min-width: 38px;
        width: 38px;
        min-height: 38px;
        height: 38px;
        border-radius: 8px;
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    p {
        margin: 0 !important;
        margin-left: 15px !important;
    }

    .title {
        font-size: $font-title;
        color: $color-primary-text;
        font-weight: bolder;
    }

    .subtitle {
        font-size: $font-small;
        color: $color-secondary-text;
        font-weight: normal;
    }

    .profile-card-dropdown {
        opacity: 0.5;
        width: 12px;
        height: 12px;
        margin-left: 30px;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;

        &.is-open {
            transform: rotate(180deg);
        }
    }
    .fade-profile-enter-active,
    .fade-profile-leave-active {
      transition: opacity 180ms ease !important;
    }

    .fade-profile-enter-from,
    .fade-profile-leave-to {
      opacity: 0;
    }

    .fade-profile-enter-to,
    .fade-profile-leave-from {
      opacity: 1;
    }
</style>